import React, { useEffect, useState } from "react";
import api from "@/api/client";
import { Megaphone, Mail, Check } from "lucide-react";

export default function AdvertisePage() {
  const [slots, setSlots] = useState([]);
  useEffect(() => {
    api.get("/ads/slots").then((r) => setSlots(r.data.slots || [])).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-16 fade-up">
      <div className="text-center mb-14">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-sky-400 mb-3">— Advertise With Us</p>
        <h1 className="font-serif text-5xl lg:text-6xl text-sky-100 tracking-tight">
          Reach thousands of <span className="italic text-sky-400">high-intent</span> shoppers.
        </h1>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto leading-relaxed">
          Our landing and article pages attract product-research traffic. Book a leaderboard slot to put your brand in front of buyers ready to click.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {slots.map((s) => (
          <div key={s.key} data-testid={`advertise-slot-${s.key}`} className="border border-slate-800 rounded-xl p-6 hover:border-sky-400/40 transition">
            <Megaphone className="w-6 h-6 text-sky-400 mb-3" strokeWidth={1.5} />
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{s.size}</p>
            <h3 className="font-serif text-xl text-sky-100 mt-1">{s.label}</h3>
            <div className="mt-4">
              <span className="font-serif text-4xl font-numeric text-sky-100">${s.price_usd}</span>
              <span className="text-sm text-slate-500 ml-2">/month</span>
            </div>
            <ul className="mt-4 space-y-1.5 text-sm text-slate-300">
              <li className="flex items-start gap-2"><Check className="w-4 h-4 text-sky-400 mt-0.5" /> Impression + click tracking</li>
              <li className="flex items-start gap-2"><Check className="w-4 h-4 text-sky-400 mt-0.5" /> Direct link to your URL</li>
              <li className="flex items-start gap-2"><Check className="w-4 h-4 text-sky-400 mt-0.5" /> {s.key.includes("top") ? "Above-the-fold visibility" : "Content-adjacent placement"}</li>
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 border border-sky-500/25 rounded-xl p-8 bg-gradient-to-br from-sky-500/8 to-transparent text-center">
        <Mail className="w-6 h-6 text-sky-400 mx-auto mb-3" />
        <h3 className="font-serif text-2xl text-sky-100">Ready to book?</h3>
        <p className="text-slate-400 mt-2">Email <a href="mailto:ads@allbusiness.online" className="text-sky-300 underline">ads@allbusiness.online</a> with your banner (728×90) and target URL. We'll invoice you monthly.</p>
      </div>
    </div>
  );
}
